
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1199_43300)"}},[_c('path',{attrs:{"d":"M8 .8a7.2 7.2 0 110 14.401A7.2 7.2 0 018 .8zm2.225 4.975a.48.48 0 00-.679 0L8 7.32 6.453 5.775a.48.48 0 00-.678.678L7.32 8 5.775 9.546a.48.48 0 00.678.679L8 8.678l1.547 1.547a.48.48 0 00.679-.679L8.678 8l1.547-1.546a.48.48 0 000-.678z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1199_43300"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    